import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { TransactionsListComponent } from './transactions-list/transactions-list.component';
import { TransactionsRoutingModule } from './transactions-routing.module';
import { TransactionLinesComponent } from './transactions-detail/transaction-line/transaction-line.component';
import { DragDropModule } from 'primeng/dragdrop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransactionsDetailComponent } from './transactions-detail/transactions-detail.component';
import { TransactionLinesJobsComponent } from './transactions-detail/transaction-lines-jobs/transaction-lines-jobs.component';
import { TransactionsDetailSummaryComponent } from './transactions-detail-summary/transactions-detail-summary.component';
import { FileUploadModule } from 'primeng/fileupload';
import { AccordionModule } from 'primeng/accordion';
import { TransactionsWorkersComponent } from './transactions-workers/transactions-workers.component';
import { TransactionsWorkersBusinessComponent } from './transactions-workers-business/transactions-workers-business.component';
import { TransactionsRetentionsComponent } from './transactions-retentions/transactions-retentions.component';
import { TooltipModule } from 'primeng/tooltip';
import { GenerateInvoiceComponent } from './generate-invoice/generate-invoice.component';
import { GenerateInvoiceCsvComponent } from './generate-invoice-csv/generate-invoice-csv.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CoreModule } from 'src/app/core/core.module';
import { TransactionsWorkerBillableItemsComponent } from './transactions-workers-billable-items-lines/transactions-workers-billable-items-lines.component';
import { DeletedLabelComponent } from 'src/app/shared/components/deleted-label/deleted-label.component';
import { WorkerBillableItem } from '../workers/_types/worker-billable-item';
import { WorkerBillableItemsGeneratorComponent } from './transactions-workers-billable-items-lines/worker-billable-items-lines-generator/worker-billable-items-lines-generator.component';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TransactionUploadExcelComponent } from './transactions-detail/transaction-upload-excel/transaction-upload-excel.component';


@NgModule({ declarations: [
        TransactionsListComponent,
        TransactionsDetailComponent,
        TransactionLinesComponent,
        TransactionLinesJobsComponent,
        TransactionsDetailSummaryComponent,
        TransactionsWorkersComponent,
        TransactionsWorkersBusinessComponent,
        TransactionsRetentionsComponent,
        GenerateInvoiceComponent,
        GenerateInvoiceCsvComponent,
        TransactionsWorkerBillableItemsComponent,
        WorkerBillableItemsGeneratorComponent,
        TransactionUploadExcelComponent
    ], imports: [CoreModule,
        TransactionsRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        AccordionModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        DragDropModule,
        BrowserAnimationsModule,
        FileUploadModule,
        TooltipModule,
        OverlayPanelModule,
        MenuModule,
        MessagesModule,
        MessageModule,
        DeletedLabelComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class TransactionsModule { }
